import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Currency from "utils/currency";

const useStyles = makeStyles(() => ({
  root: {
  }
}));

const MoneyDisplay = props => {
  const { className, component: Component, currency, amount, ...rest } = props;

  const classes = useStyles();
  return (
    <Component className={clsx(classes.root, className)} {...rest}>
      {Currency.compress(amount, currency)} {currency}
    </Component>
  );
};

MoneyDisplay.propTypes = {
  component: PropTypes.node,
  className: PropTypes.string,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired
};

MoneyDisplay.defaultProps = {
  component: "span"
};

export default MoneyDisplay;
